import { render, staticRenderFns } from "./logEntidade.vue?vue&type=template&id=306e8b9e"
import script from "./logEntidade.ts?vue&type=script&lang=js&external"
export * from "./logEntidade.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('306e8b9e')) {
      api.createRecord('306e8b9e', component.options)
    } else {
      api.reload('306e8b9e', component.options)
    }
    module.hot.accept("./logEntidade.vue?vue&type=template&id=306e8b9e", function () {
      api.rerender('306e8b9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/logEntidade/logEntidade.vue"
export default component.exports